var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"auth-support"},[_c('el-button',{staticClass:"support-btn",on:{"click":_vm.open}},[_vm._v(_vm._s(_vm.btnText))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }